module.exports = __webpack_public_path__ + "img/500.fc8c52ca.png";